
import { useEffect, useState } from 'react';
import { CURRENT_URL } from '../../config/runtimeConfig';
import { communes, wilayas } from '../../data';
import '../invoiceFormat/invoiceFormat.css';
import './invoiceEndFormat.css';

export default function InvoiceEndFormat({ lengthEnvois, invoice, settings }) {
    const [sharedWilaya, setSharedWilaya] = useState("");
    const [sharedCommune, setSharedCommune] = useState("");

    useEffect(() => {
        setSharedWilaya(wilayas.filter(item => item.id === settings.wilaya)[0]['nom']);
        setSharedCommune(communes[settings.wilaya].filter(item => item.id === settings.commune)[0]['nom']);
    }, [])

    return (
        <div className='invoice-format' id={`invoice-99`}>
            <div className="title">
                <div className="name">{settings.fullname}</div>
                <div className="logo">
                    <img src={`${CURRENT_URL}//nweblack.png`} />
                </div>
            </div>
            <div className="address">
                <p>{settings.address}</p>
                <p>{sharedCommune}, {sharedWilaya}, Algérie</p>
                <p>Téléphone: {settings.telephone}</p>
            </div>
            <div className="business-register">
                <p>RC N° : {settings.rc}</p>
                <p>NIF N°: {settings.nif}</p>
                <p>NIS N°: {settings.nis}</p>
                <p>AI N° : {settings.ai}</p>
                <p>Capital: {settings.capital} DA</p>
            </div>
            <div className="box">
                <div className="box-title">Facture</div>
                <div className="box-header">
                    <div className="box-left">
                        <div className="line">
                            <span>Facture N°</span>
                            <span>C/Facture {`${invoice.invoiceMonth}-${invoice.id}`}</span>
                        </div>
                        <div className="line">
                            <span>Raison Sociale</span>
                            <span>{invoice.Entreprise.nom}</span>
                        </div>
                        <div className="line">
                            <span>Adresse</span>
                            <span>{invoice.Entreprise.address}</span>
                        </div>
                        <div className="line">
                            <span>RC N°</span>
                            <span>{invoice.Entreprise.rc}</span>
                        </div>
                        <div className="line">
                            <span>NIF N°</span>
                            <span>{invoice.Entreprise.nif}</span>
                        </div>
                        <div className="line">
                            <span>NIS N°</span>
                            <span>{invoice.Entreprise.nis}</span>
                        </div>
                        <div className="line">
                            <span>AI N°</span>
                            <span>{invoice.Entreprise.ai}</span>
                        </div>
                    </div>
                    <div className="box-right">
                        <div className="line">
                            <span>Date</span>
                            <span>{invoice.Entreprise.createdAt.slice(0, 10)}</span>
                        </div>
                        <div className="line">
                            <span>Nombre Total d'envois</span>
                            <span>{lengthEnvois}</span>
                        </div>
                        {/* <div className="line">
                            <span>Page</span>
                            <span>{`${page + 1}/${pages}`}</span>
                        </div> */}
                    </div>
                </div>
                <ul className="invoice-detail">
                    <li>
                        <span>Total H.T</span>
                        <span>{Number.parseFloat(invoice.totalEnvois * 1 + invoice.totalRamassage * 1 + invoice.totalDepot * 1).toFixed(2)}</span>
                    </li>
                    <li>
                        <span>TVA (19%)</span>
                        <span>{Number.parseFloat((invoice.totalEnvois * 1 + invoice.totalRamassage * 1 + invoice.totalDepot * 1) * 0.19).toFixed(2)}</span>
                    </li>
                    <li>
                        <span>Total TTC</span>
                        <span>{Number.parseFloat((invoice.totalEnvois * 1 + invoice.totalRamassage * 1 + invoice.totalDepot * 1) * 1.19).toFixed(2)}</span>
                    </li>
                    <li>
                        <span>Montant Global</span>
                        <span>{Number.parseFloat(invoice.totalEnvoisMontant).toFixed(2)}</span>
                    </li>
                    <li>
                        <span>Total a payer</span>
                        <span>{Number.parseFloat(invoice.montant).toFixed(2)}</span>
                    </li>
                </ul>
                <div className="footer">
                    <p>Pour toute communication avec le service facturation</p>
                    <p>facturation@nwexpress.com</p>
                    <p>0560 97 00 16 / 0560 89 45 44 / 0560 92 84 54</p>
                    <p>Délai de paiement: Le client est tenu de procéder au paiement de cette facture dans un délai de 15 jours à compter de la date de livraison</p>
                    <div className='footer-last'>
                        <div>NWEXPRESS SERVICE S.A.R.L</div>
                        <div>AGB: 03200008677180120811</div>
                        <div>BNP: 02700707000060300105</div>
                    </div>
                </div>
            </div>
        </div>
    )
}